import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

import Sidebar from "@/components/Sidebar";

import api, { formatApiError } from "@/lib/api";

import { useNavigate } from "react-router-dom";

import { toast } from "sonner";

import {

  ArrowLeft,

  Bot,

  Check,

  ChevronDown,

  Clock,

  Globe,

  Headphones,

  Mic,

  Phone,

  ShieldCheck,

  Sparkles,

  UserRound,

  Users,

  Pencil,

} from "lucide-react";





export default function SetupReceptionist() {

  const navigate = useNavigate();



  const [form, setForm] = useState({

    receptionistName: "Maya",

    language: "English",

    voice: "Professional Female",

    personality: "Friendly & Professional",

    allowAppointments: true,

    allowRescheduling: true,

    allowCancellation: true,

    requirePhone: true,

    humanEscalation: true,

    takeMessages: true,

    vobiz_phone_number: "",

  });



  const [saved, setSaved] = useState(false);

  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");

  const [loadingConfig, setLoadingConfig] = useState(true);

  const [isConfigured, setIsConfigured] = useState(false);

  const [business, setBusiness] = useState(null);



useEffect(() => {

  loadReceptionistConfig();

  loadBusiness();

}, []);



const loadReceptionistConfig = async () => {

  try {

    setLoadingConfig(true);



    const response = await fetch("/api/receptionist/config", {

      method: "GET",

      credentials: "include",

      headers: {

        Accept: "application/json",

      },

    });



    if (!response.ok) {

      throw new Error(

        `Failed to load receptionist config: ${response.status}`

      );

    }



    const data = await response.json();



    console.log("Receptionist config loaded:", data);



    // Populate the form from backend

    setForm({

      receptionistName:

        data.receptionistName || "Maya",



      language:

        data.language || "English",



      voice:

        data.voice || "Professional Female",



      personality:

        data.personality || "Friendly & Professional",



      allowAppointments:

        data.allowAppointments ?? true,



      allowRescheduling:

        data.allowRescheduling ?? true,



      allowCancellation:

        data.allowCancellation ?? true,



      requirePhone:

        data.requirePhone ?? true,



      humanEscalation:

        data.humanEscalation ?? true,



      takeMessages:

        data.takeMessages ?? true,



      vobiz_phone_number:

        data?.phone?.vobiz_phone_number || "",

    });



    // THIS is the important part

    const connected =

      data?.retell?.connected === true &&

      !!data?.retell?.agent_id;



    setIsConfigured(connected);



  } catch (error) {

    console.error(

      "Failed to load receptionist configuration:",

      error

    );



    setIsConfigured(false);



  } finally {

    setLoadingConfig(false);

  }

};



  const loadBusiness = async () => {

    try {

      const response = await fetch("/api/business", {

        method: "GET",

        credentials: "include",

        headers: {

          Accept: "application/json",

        },

      });



      if (!response.ok) {

        throw new Error(`Failed to load business: ${response.status}`);

      }



      const data = await response.json();



      setBusiness(data?.configured ? data?.business || null : null);

    } catch (error) {

      console.error("Failed to load business:", error);

      setBusiness(null);

    }

  };

  const updateField = (field, value) => {

    setForm((prev) => ({

      ...prev,

      [field]: value,

    }));

    setSaved(false);

  };



  const handleSave = async () => {

  setSaving(true);

  setSaved(false);

  setError("");



  try {

    const response = await fetch("/api/receptionist/config", {

      method: "PATCH",

      credentials: "include",

      headers: {

        "Content-Type": "application/json",

      },

      body: JSON.stringify(form),

    });



    const data = await response.json();



    if (!response.ok) {

      throw new Error(

        data?.detail || "Could not save receptionist configuration."

      );

    }



    setSaved(true);



  } catch (err) {

    setError(

      err?.message ||

      "Could not save receptionist configuration."

    );

  } finally {

    setSaving(false);

  }

};



  return (

    <div className="min-h-screen bg-[#F7F7F2] text-[#102C2D]">

      <Sidebar />



      <main className="lg:ml-[260px] min-h-screen">

        {/* Header */}

        <div className="border-b border-[#E0E6DE] bg-[#FDFDF9]">

          <div className="px-5 py-4 md:px-7">

            <button

              type="button"

              onClick={() => navigate("/receptionist")}

              className="mb-4 flex items-center gap-2 text-sm font-medium text-[#71817C] transition hover:text-[#102C2D]"

            >

              <ArrowLeft size={17} />

              Back to AI Receptionist

            </button>



            <div className="flex flex-col justify-between gap-4 md:flex-row md:items-center">

              <div>

                <div className="mb-2 flex items-center gap-3">

                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#E8F4EF]">

                    <Bot className="h-6 w-6 text-[#075B59]" />

                  </div>



                  <div>

                    <h1 className="text-2xl font-semibold tracking-tight">

                      Set Up AI Receptionist

                    </h1>



                    <p className="mt-1 text-sm text-[#71817C]">

                      Configure how your receptionist should represent your

                      business.

                    </p>

                  </div>

                </div>

              </div>



             <button

                type="button"

                onClick={handleSave}

                disabled={saving}

                className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#075B59] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#064B49] disabled:cursor-not-allowed disabled:opacity-60"

              >

                {saving ? (

                  <>

                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />

                    Saving…

                  </>

                ) : saved ? (

                  <>

                    <Check size={17} />

                    Saved

                  </>

                ) : (

                  <>

                    <Check size={17} />

                    Save Configuration

                  </>

                )}

              </button>

            </div>

          </div>

        </div>



        {/* Main Content */}

        <div className="w-full px-4 py-5 md:px-5 md:py-5">

          <div className="mx-auto max-w-[1440px]">

            <div className="grid items-start gap-5 xl:grid-cols-[minmax(0,1fr)_320px] 2xl:grid-cols-[minmax(0,1fr)_340px]">

              {/* Main Configuration */}

              <div className="space-y-4">

                {/* Identity */}

                <Section

                  icon={<UserRound size={19} />}

                  title="Receptionist Identity"

                  description="Define the basic identity your AI receptionist will use during calls."

                >

                  <div className="grid gap-5 md:grid-cols-2">

                    <InputField

                      label="Receptionist Name"

                      value={form.receptionistName}

                      onChange={(e) =>

                        updateField("receptionistName", e.target.value)

                      }

                      placeholder="e.g. Maya"

                    />



                    <SelectField

                      label="Language"

                      value={form.language}

                      onChange={(e) =>

                        updateField("language", e.target.value)

                      }

                      options={[

                        "English",

                        "Hindi",

                        "Marathi",

                        "English + Hindi",

                        "English + Marathi",

                      ]}

                    />





                    <SelectField

                      label="Personality"

                      value={form.personality}

                      onChange={(e) =>

                        updateField("personality", e.target.value)

                      }

                      options={[

                        "Friendly & Professional",

                        "Warm & Conversational",

                        "Professional & Concise",

                      ]}

                    />

                  </div>

                </Section>



                {/* Business Context */}

                <Section

                  icon={<Globe size={19} />}

                  title="Business Information"

                  description="Your AI receptionist uses your business information when answering customer calls."

                >

                  <div className="rounded-xl border border-[#E0E6DE] bg-[#F8F8F3] p-4">

                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                      <div>

                        <p className="text-xs font-medium uppercase tracking-wide text-[#8A9992]">

                          Business

                        </p>

                        <p className="mt-1 text-sm font-medium text-[#24413F]">

                          {business?.business_name || "Not configured"}

                        </p>

                      </div>



                      <div>

                        <p className="text-xs font-medium uppercase tracking-wide text-[#8A9992]">

                          Business Phone

                        </p>

                        <p className="mt-1 text-sm font-medium text-[#24413F]">

                          {business?.phone || "Not added"}

                        </p>

                      </div>



                      <div>

                        <p className="text-xs font-medium uppercase tracking-wide text-[#8A9992]">

                          Business Hours

                        </p>

                        <p className="mt-1 text-sm font-medium text-[#24413F]">

                          {business?.opening_time && business?.closing_time

                            ? `${business.opening_time} – ${business.closing_time}`

                            : "Not configured"}

                        </p>

                      </div>



                      <div>

                        <p className="text-xs font-medium uppercase tracking-wide text-[#8A9992]">

                          Location

                        </p>

                        <p className="mt-1 text-sm font-medium text-[#24413F]">

                          {business?.address?.city && business?.address?.state

                            ? `${business.address.city}, ${business.address.state}`

                            : "Not added"}

                        </p>

                      </div>

                    </div>



                    <div className="mt-6 flex justify-start">

                      <button

                        type="button"

                        onClick={() => navigate("/business-settings")}

                        className="inline-flex items-center gap-2 rounded-lg border border-[#BFDCD2] px-4 py-2 text-sm font-medium text-[#075B59] transition hover:bg-[#F0F7F2]"

                      >

                        <Pencil className="h-4 w-4" />

                        Edit Business Details

                      </button>

                    </div>



                    <div className="mt-4 flex items-start gap-3 rounded-lg border border-[#D5E8DE] bg-[#F0F7F2] p-4">

                      <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#075B59]" />



                      <p className="text-sm leading-6 text-slate-600">

                       Add the number customers find on your website or social media. Your AI receptionist will use it to handle customer calls.   </p>

                    </div>

                  </div>

                </Section>



                {/* Appointment Behavior */}

                <Section

                  icon={<Clock size={19} />}

                  title="Appointment Handling"

                  description="Choose which appointment actions your receptionist should support."

                >

                  <div className="divide-y divide-[#E9EDE6] rounded-xl border border-[#E0E6DE] bg-white">

                    <ToggleRow

                      title="Accept new appointments"

                      description="Allow callers to request new appointments."

                      checked={form.allowAppointments}

                      onChange={(value) =>

                        updateField("allowAppointments", value)

                      }

                    />



                    <ToggleRow

                      title="Reschedule appointments"

                      description="Allow callers to move an existing appointment."

                      checked={form.allowRescheduling}

                      onChange={(value) =>

                        updateField("allowRescheduling", value)

                      }

                    />



                    <ToggleRow

                      title="Cancel appointments"

                      description="Allow callers to cancel an existing appointment."

                      checked={form.allowCancellation}

                      onChange={(value) =>

                        updateField("allowCancellation", value)

                      }

                    />



                    <ToggleRow

                      title="Require caller phone number"

                      description="Use the caller's phone number to identify or create a customer."

                      checked={form.requirePhone}

                      onChange={(value) =>

                        updateField("requirePhone", value)

                      }

                    />

                  </div>

                </Section>



                {/* Conversation Behavior */}

                <Section

                  icon={<Headphones size={19} />}

                  title="Conversation Behavior"

                  description="Control how your receptionist handles conversations."

                >

                  <div className="divide-y divide-[#E9EDE6] rounded-xl border border-[#E0E6DE] bg-white">

                    <ToggleRow

                      title="Human escalation"

                      description="Allow the receptionist to escalate a caller to a human when needed."

                      checked={form.humanEscalation}

                      onChange={(value) =>

                        updateField("humanEscalation", value)

                      }

                    />



                    <ToggleRow

                      title="Take messages"

                      description="Allow the receptionist to capture messages when the right person is unavailable."

                      checked={form.takeMessages}

                      onChange={(value) =>

                        updateField("takeMessages", value)

                      }

                    />

                  </div>

                </Section>

              </div>



              {/* Right Preview */}

              <div className="space-y-4">

                <motion.div

                  initial={{ opacity: 0, y: 10 }}

                  animate={{ opacity: 1, y: 0 }}

                  className="xl:sticky xl:top-5 overflow-hidden rounded-2xl border border-[#E0E6DE] bg-white shadow-[0_4px_18px_rgba(16,44,45,0.04)]"

                >

                  <div className="border-b border-[#E9EDE6] bg-gradient-to-br from-[#ecfaf7] via-white to-white px-5 py-4">

                    {/* Preview header */}

                    <div className="flex items-center justify-between gap-3">

                      <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#075B59]">

                        Receptionist Preview

                      </span>



                      <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#CBE5DA] bg-[#F0F7F2] px-2.5 py-1 text-[11px] font-semibold text-[#075B59]">

                        <span className="h-1.5 w-1.5 rounded-full bg-[#21a47e]" />

                        Ready

                      </span>

                    </div>

                    {/* Receptionist identity */}
                    <div className="flex flex-col items-center pt-5 text-center">
                      {/* AI avatar image */}
                      <div className="relative h-[170px] w-[170px] shrink-0 overflow-hidden rounded-full">
                        <img
                          src="/images/nexa-ai-avatar.png"
                          alt="AI receptionist"
                          className="h-full w-full object-contain"
                        />
                      </div>

                      {/* Receptionist name — show only once */}
                      <h2 className="mt-3 text-2xl font-semibold tracking-tight text-[#102C2D]">
                        {form.receptionistName || "Your Receptionist"}
                      </h2>

                      <p className="mt-1 text-sm text-[#71817C]">
                        AI Receptionist
                      </p>
                    </div>


                  </div>



                  <div className="space-y-4 p-6">

                    <PreviewRow

                      icon={<Globe size={16} />}

                      label="Language"

                      value={form.language}

                    />



                    <PreviewRow

                      icon={<Mic size={16} />}

                      label="Voice"

                      value={form.voice}

                    />



                    <PreviewRow

                      icon={<Sparkles size={16} />}

                      label="Style"

                      value={form.personality}

                    />



                    <PreviewRow

                      icon={<CalendarIcon />}

                      label="Appointments"

                      value={

                        form.allowAppointments ? "Enabled" : "Disabled"

                      }

                    />



                    <PreviewRow

                      icon={<Users size={16} />}

                      label="Human Escalation"

                      value={

                        form.humanEscalation ? "Enabled" : "Disabled"

                      }

                    />

                  </div>



                  <div className="border-t border-[#E9EDE6] p-6">

                    <div className="rounded-xl bg-[#F8F8F3] p-4">

                      <div className="mb-2 flex items-center gap-2">

                        <Phone size={16} className="text-[#075B59]" />



                        <span className="text-sm font-semibold">

                          Phone Connection

                        </span>

                      </div>



                      <p className="text-xs leading-5 text-[#71817C]">

                        Your business phone number will be connected after the

                        receptionist configuration is complete.

                      </p>

                    </div>

                  </div>

                </motion.div>

              </div>

            </div>

          </div>

        </div>

      </main>

    </div>

  );

}



/\* ---------------- Components ---------------- \*/



function Section({ icon, title, description, children }) {

  return (

    <section className="overflow-hidden rounded-2xl border border-[#E0E6DE] bg-white shadow-[0_3px_14px_rgba(16,44,45,0.035)]">

      <div className="border-b border-[#E9EDE6] px-5 py-4 md:px-6">

        <div className="flex items-start gap-3">

          <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-lg bg-[#E8F4EF] text-[#075B59]">

            {icon}

          </div>



          <div>

            <h2 className="font-semibold text-[#102C2D]">

              {title}

            </h2>



            <p className="mt-1 text-sm leading-5 text-[#71817C]">

              {description}

            </p>

          </div>

        </div>

      </div>



      <div className="p-3 md:p-4">{children}</div>

    </section>

  );

}



function InputField({ label, value, onChange, placeholder }) {

  return (

    <label className="block">

      <span className="mb-2 block text-sm font-medium text-[#304B48]">

        {label}

      </span>



      <input

        value={value}

        onChange={onChange}

        placeholder={placeholder}

        className="w-full rounded-xl border border-[#E0E6DE] bg-white px-3.5 py-2.5 text-sm outline-none transition placeholder:text-[#8A9992] focus:border-[#075B59] focus:ring-2 focus:ring-[#075B59]/10"

      />

    </label>

  );

}



function SelectField({ label, value, onChange, options }) {

  return (

    <label className="block">

      <span className="mb-2 block text-sm font-medium text-[#304B48]">

        {label}

      </span>



      <div className="relative">

        <select

          value={value}

          onChange={onChange}

          className="w-full appearance-none rounded-xl border border-[#E0E6DE] bg-white px-4 py-2.5 pr-10 text-sm outline-none transition focus:border-[#075B59] focus:ring-2 focus:ring-[#075B59]/10"

        >

          {options.map((option) => (

            <option key={option} value={option}>

              {option}

            </option>

          ))}

        </select>



        <ChevronDown

          size={17}

          className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#8A9992]"

        />

      </div>

    </label>

  );

}



function InfoRow({ label, value }) {

  return (

    <div>

      <p className="text-xs font-medium uppercase tracking-wide text-[#8A9992]">

        {label}

      </p>



      <p className="mt-1 text-sm font-medium text-[#304B48]">

        {value}

      </p>

    </div>

  );

}



function ToggleRow({

  title,

  description,

  checked,

  onChange,

}) {

  return (

    <div className="flex items-center justify-between gap-4 px-5 py-4">

      <div>

        <p className="text-sm font-semibold text-[#24413F]">

          {title}

        </p>



        <p className="mt-1 max-w-xl text-xs leading-5 text-[#71817C]">

          {description}

        </p>

      </div>



      <button

        type="button"

        onClick={() => onChange(!checked)}

        className={`relative h-6 w-11 shrink-0 rounded-full transition ${

          checked ? "bg-[#075B59]" : "bg-[#CBD5CF]"

        }`}

        aria-pressed={checked}

      >

        <span

          className={`absolute top-1 h-4 w-4 rounded-full bg-white shadow-sm transition ${

            checked ? "left-6" : "left-1"

          }`}

        />

      </button>

    </div>

  );

}



function PreviewRow({ icon, label, value }) {

  return (

    <div className="flex items-center justify-between gap-3">

      <div className="flex items-center gap-2 text-[#71817C]">

        {icon}



        <span className="text-xs">{label}</span>

      </div>



      <span className="max-w-[170px] truncate text-right text-xs font-medium text-[#304B48]">

        {value}

      </span>

    </div>

  );

}



function CalendarIcon() {

  return (

    <svg

      width="16"

      height="16"

      viewBox="0 0 24 24"

      fill="none"

      stroke="currentColor"

      strokeWidth="2"

      strokeLinecap="round"

      strokeLinejoin="round"

    >

      <rect x="3" y="4" width="18" height="18" rx="2" />

      <line x1="16" y1="2" x2="16" y2="6" />

      <line x1="8" y1="2" x2="8" y2="6" />

      <line x1="3" y1="10" x2="21" y2="10" />

    </svg>

  );

}